import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { ISkillDomainResource } from "../types";

export type ISkillDomainDeleteMutationParameters = {
    skillDomain: RelationalValue<ISkillDomainResource>;
};

export type ISkillDomainDeleteMutationResult = void;

export const skillDomainDeleteMutation: IApiMutationFunction<ISkillDomainDeleteMutationParameters> = ({
    skillDomain,
}) => {
    return {
        method: "DELETE",
        url: `/skill_domains/${mapRelationalValue(skillDomain)}`,
    };
};

export const useSkillDomainDeleteMutation = createApiMutationHook<
    ISkillDomainDeleteMutationParameters,
    ISkillDomainDeleteMutationResult
>(skillDomainDeleteMutation);
